import { Container, Skeleton } from '@mui/material';

import { containerStyles } from './MainSkeleton.styles';

const MainSkeleton = () => {
	return (
		<Container sx={containerStyles}>
			<Skeleton variant="rounded" width="100%" height={40} sx={{ marginTop: '1rem' }} />
			<Skeleton variant="rounded" width="100%" height={80} sx={{ marginTop: '1rem' }} />
			<Skeleton variant="rounded" width="100%" height={80} sx={{ marginTop: '1rem' }} />
		</Container>
	);
};

export default MainSkeleton;
